import { twMerge } from 'tailwind-merge';
import { useRutilusQuery } from '../../../../../api/graphql/useRutilusQuery';
import { FishingWaterCard } from '../../../../../components/Cards/FishingWaterCard/FishingWaterCard';
import { ContinuousCarousel } from '../../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { NonCrawlableLink } from '../../../../../components/Clickables/NonCrawlableLink/NonCrawlableLink';
import {
  Container,
  DEFAULT_CONTAINER_PADDING,
} from '../../../../../components/Container/Container';
import { useGeolocation } from '../../../../../contexts/GeolocationContext/GeolocationContext';
import {
  GetNearbyFishingWaters,
  GetNearbyFishingWatersVariables,
} from '../../../../../interfaces/graphql';
import { getNearbyFishingWaters } from '../../../../../queries/rutilus/FishingWaters';

interface IProps {
  postSlug: string;
  title: string;
  className?: string;
}

export const NearbyWaters = ({ postSlug, title, className }: IProps) => {
  const { isLoading, location } = useGeolocation();
  const { data, loading } = useRutilusQuery<
    GetNearbyFishingWaters,
    GetNearbyFishingWatersVariables
  >(getNearbyFishingWaters, {
    variables: location?.coordinates,
    skip: isLoading,
  });

  if (loading || !data || data.suggestedFishingWaters.length === 0) {
    return <></>;
  }

  const { suggestedFishingWaters } = data;

  return (
    <div className={twMerge(`pb-md sm:mt-18 bg-lake-fog pt-6 sm:pt-10 md:pt-14`, className)}>
      <Container>
        <ContinuousCarousel
          dataTestId="nearby-waters"
          title={title}
          childrenClassName="w-col-3 sm:w-col-6 md:w-col-3 min-w-col-3 sm:min-w-col-6 md:min-w-col-3"
        >
          {suggestedFishingWaters.map((water, index) => (
            <FishingWaterCard
              key={`nearby-water-${water._id}`}
              imageWidth={372}
              latitude={water.latitude}
              longitude={water.longitude}
              name={water.displayName}
              numberOfCatches={water.catchesCount}
              waterId={water._id}
              clickEventSource="blog_post_waters"
              clickEventSourceId={postSlug}
              clickEventPosition={index}
              countryName={water.country?.countryName}
              regionName={water.region?.name || undefined}
            />
          ))}
        </ContinuousCarousel>
      </Container>
      <div className={`${DEFAULT_CONTAINER_PADDING} mt-10 flex justify-end`}>
        <NonCrawlableLink
          routerPushTo="/explore"
          variant="buttonPrimary"
          ariaLabel="Explore full map"
        >
          Explore full map
        </NonCrawlableLink>
      </div>
    </div>
  );
};
